module.exports = __webpack_public_path__ + "img/enjojj_logo.4e1728bc.png";